var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCryptoGeneralIconsTimeClean = function SvgCryptoGeneralIconsTimeClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.3 17.3",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 0c4.8 0 8.7 3.8 8.7 8.6s-4 8.7-8.7 8.7S0 13.3 0 8.6 3.9 0 8.6 0zm0 1.3c-4 0-7.3 3.3-7.3 7.3s3.3 7.3 7.3 7.3c4.1 0 7.3-3.3 7.3-7.3s-3.3-7.3-7.3-7.3zm.7 1.9v5.2l3.1 3.1-.9.9L8 8.9V3.2h1.3z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};

export { SvgCryptoGeneralIconsTimeClean as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNy4zIDE3LjMiPjxwYXRoIGQ9Ik04LjYgMGM0LjggMCA4LjcgMy44IDguNyA4LjZzLTQgOC43LTguNyA4LjdTMCAxMy4zIDAgOC42IDMuOSAwIDguNiAwem0wIDEuM2MtNCAwLTcuMyAzLjMtNy4zIDcuM3MzLjMgNy4zIDcuMyA3LjNjNC4xIDAgNy4zLTMuMyA3LjMtNy4zcy0zLjMtNy4zLTcuMy03LjN6bS43IDEuOXY1LjJsMy4xIDMuMS0uOS45TDggOC45VjMuMmgxLjN6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";